<template>
  <div class="form-row">

    <div v-for="(input,index) in prepareInputsConfig" :class="itemClass">

      <general-input1 :form="form" :inputConfig="input" v-if="['number','text'].indexOf(input.type) > -1"
                      :key="index"/>

      <select-box-input1 :form="form" :inputConfig="input" v-if="input.type == 'selectbox'"
                         :key="index"/>

      <radio-box1 :form="form" :inputConfig="input" v-if="input.type == 'radiobox'"
                  :key="index"/>

      <text-area1
          :form="form" :inputConfig="input" v-if="input.type == 'textarea'"
          :key="index"/>


      <editor1
          :form="form" :inputConfig="input" v-if="input.type == 'editor'"
          :key="index"/>

    </div>
  </div>
</template>

<script>
/*
* support number selectbox and text
*/

import {defineComponent} from 'vue'
import GeneralInput1 from "./Components/GeneralInput/GeneralInput1.vue";
import SelectBoxInput1 from "./Components/SelectBox/SelectBoxInput1.vue";
import TextArea1 from "./Components/TextArea/TextArea1.vue";
import RadioBox1 from "./Components/RadioBox/RadioBox1.vue";
import Editor1 from "./Components/Editor/Editor1.vue";
import {generateHash} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart";

export default defineComponent({
  name: "AdvanceDescription1",
  components: {RadioBox1, SelectBoxInput1, GeneralInput1, TextArea1, Editor1},
  data() {
    return {
      form: {}
    }
  },
  props: {
    inputsConfig: {
      default: ''
    },
    description: {
      default: ''
    },
    itemClass: {
      default: 'col-lg-4'
    }
  },
  computed: {
    prepareInputsConfig() {
      let inputs = JSON.parse(this.inputsConfig);
      inputs.forEach(item => {
        const id = item.name;
        item['id'] = id
        item['hash'] = generateHash()

        let description = this.compileDescription(this.description)
        this.form[id] = ''

        if (description != null && Object.keys(description).indexOf(id) > -1) {
          this.form[id] = description[id]
        }
      })
      return inputs
    }
  },
  methods: {
    compileDescription(description) {
      try {
        return JSON.parse(description)
      } catch (e) {
        return {}
      }
    }
  },
  watch: {
    form: {
      handler(oldValue, newValue) {
        this.$emit('update:modelValue', JSON.stringify(newValue))
      },
      deep: true
    }
  }
})
</script>

<style scoped>

</style>